<div class="user-block">
    <div class="greeting">
        <span>{{ greetingKey | translate }} {{ user?.FirstName }}</span>
    </div>
    <div class="account">
        <span>{{ 'Account' | translate }}: </span>
        <span class="userName">{{ user?.CustomerId }}</span>
    </div>
    <div class="user-information" *ngIf="false">
        <div class="username">{{ user?.UserName || 'username' }}</div>
        <div class="email">{{ user?.Email || 'test@parcelpro.com' }}</div>
    </div>
    <div class="user-icon"
         *ngIf="false"
         [class.is-admin]="user?.IsAdmin"
         [matMenuTriggerFor]="menu"
         matTooltip="{{ user?.FirstName + ' ' + user?.LastName }}">
        <span>{{ getUserInitial() }}</span>
    </div>
</div>

<mat-menu #menu="matMenu" [overlapTrigger]="false">
    <button mat-menu-item (click)="navigateTo('user-settings')">
        <mat-icon>person</mat-icon>
        <span>My Profile</span>
    </button>
    <button mat-menu-item (click)="logout()">
        <mat-icon>power_settings_new</mat-icon>
        <span>Logout</span>
    </button>
</mat-menu>
